import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Table } from 'src/components';
import { CollapsibleSubCategoryRow } from 'src/components/SubCategoriesTable/components';
import { columns } from 'src/screens/services/ServicesScreen.data';

export const SubCategoriesTable = ({
  category,
  shouldShowHeader = true,
}: any) => {

  const normalizedServices = category?.services?.map((service: any) => {
    return {
      category,
      subCategory: null,
      ...service,
    };
  });


  return (
    <Box>
      <Box sx={{
        overflow: 'auto',
      }}>
        {
          shouldShowHeader ? (
            <Box sx={{
              width: 'fit-content'
            }}>
              <Table
                rows={[]}
                shouldShowOnlyHeader
                columns={columns}
                onRowClick={() => {}}
              />
            </Box>
          ) : null
        }

        {category?.children?.map((subCategory: any) => {
          const normalizedServices = subCategory?.services?.map((service: any) => {
            return {
              category,
              subCategory,
              ...service,
            };
          });

          return (<CollapsibleSubCategoryRow
            key={subCategory?.title}
            title={subCategory?.title}
            services={normalizedServices}
          />);
        })}
        {category?.services?.length ? (
          <CollapsibleSubCategoryRow
            title={'No subcategory'}
            services={normalizedServices}
          />
        ) : null}
      </Box>
    </Box>
  )
};
